import React from 'react'

import QuestionStandardTop from './QuestionStandardTop'

const FileQuestion = props => {
  const { question, response, onRespond, validateResponse } = props
  const outputField = () => {
    return (
      <input
        type="file"
        name={`file.${question.id}`}
        onChange={t => {
          onRespond(question, t.target.value, false)
        }}
        onBlur={() => validateResponse(question, response)}
        className="form-control"
      />
    )
  }

  return (
    <div>
      <QuestionStandardTop question={question} />
      {outputField()}
    </div>
  )
}

export default FileQuestion
